import { useEffect, useState, useRef } from 'react'
import GetDataSet, {
  deleteUploadedFile,
  uploadCustomDataset
} from '../../../services/data'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Loader from '../../../components/loader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck,
  faL,
  faDownload,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { insertdataset } from '../../../services/data'
import { Tooltip } from '@mui/material'
import IonIcon from '@reacticons/ionicons'
import useDebounce from '../../../hooks/useDebounce'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { TfiFilter } from 'react-icons/tfi'
import useRippleEffect from '../../../hooks/tripleEffects'
import TrainFilterDropdownPopup from '../../../components/trainfilterdropdownpopup'
import FilterDropDownHook from '../../../hooks/filterdropdownhook'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { format } from 'date-fns'
import InfoIconWithToolTip from '../../../util/tooltipwrapper'
import validateJSON from '../../../util/jsonvalidation'
import {
  MDXEditor,
  BoldItalicUnderlineToggles,
  toolbarPlugin,
  CreateLink,
  linkDialogPlugin,
  headingsPlugin,
  listsPlugin,
  linkPlugin,
  quotePlugin,
  thematicBreakPlugin,
  markdownShortcutPlugin,
  maxLengthPlugin
} from '@mdxeditor/editor'

import '@mdxeditor/editor/style.css'
import '../../../styles/training.css'
import { useLocation, useParams } from 'react-router-dom'

const Article = () => {
  const limit = 10
  const itemsPerPage = 10
  const [data, setData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedItems, setSelectedItems] = useState({})
  const [showDeleteWarning, setShowDeleteWarning] = useState(false)
  const [itemsCount, setItemsCount] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formDialogopen, setformDialogopen] = useState(false)
  const [updateDialogopen, setupdateDialogopen] = useState(false)
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false)
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    sourceType: 'content'
  })
  const [status, setStatus] = useState('')
  const [type, setType] = useState('')
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange
  const [fromdate, setfromdate] = useState()
  const [todate, settodate] = useState()
  const [onfiltering, setonfiltering] = useState(false)
  const [error, setError] = useState('')
  const [selectedFile, setSelectedFile] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const [validationReportUrl, setValidationReportUrl] = useState(null)
  const [uploadProgress, setUploadProgress] = useState(0)
  const fileInputRef = useRef(null)
  const [showModal, setShowModal] = useState()
  const [storeDelete, setstoreDelete] = useState()

  let totalItems = 0

  const { ripple, createRipple } = useRippleEffect()
  const { handleopenClosedropdown, isopenpopup } = FilterDropDownHook()
  const datepickerref = useRef(null)

  const [totalproducts, Settotalproducts] = useState(0)

  const acceptedFileTypes = ['.csv', '.xlsx']
  const maxFileSize = 2 * 1024 * 1024
  const closefilterpopup = () => {
    handleopenClosedropdown()
  }

  const debouncedSearchTerm = useDebounce(searchTerm, 2000)
  const [activeTab, setActiveTab] = useState('content') // 'content' or 'url'

  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const storeid = getStoreIdFromUrl()

  useEffect(() => {
    if (activeTab === 'content') {
      setFormData(prev => ({
        ...prev,
        url: ''
      }))
    } else if (activeTab === 'url') {
      setFormData(prev => ({
        ...prev,
        content: ''
      }))
    }
  }, [activeTab])

  const fetchSpecificData = async (page = 1) => {
    const [start, end] = dateRange

    try {
      const dataSet = new GetDataSet({
        storeId: storeid,
        id: '',
        limit: limit,
        page: page,
        type: 'article',
        status: status,
        shopify_dataset_type: type,
        created_at_from:
          start !== null ? format(new Date(start), 'yyyy-MM-dd') : '',
        created_at_to: end !== null ? format(new Date(end), 'yyyy-MM-dd') : '',
        search: debouncedSearchTerm || '',
        sort: 'createdAt',
        order: 'DESC'
      })

      const chatbotData = debouncedSearchTerm
        ? await dataSet.searchData(debouncedSearchTerm, 'article')
        : await dataSet.fetchData()

      if (chatbotData.success) {
        setData(chatbotData.data)
        totalItems = chatbotData.pagination?.total || 0
        Settotalproducts(chatbotData.pagination?.total || 0)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
      } else {
        setData([])
        setTotalPages(1)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    fetchSpecificData()
  }, [])

  // Fetch data when searchTerm changes
  useEffect(() => {
    setCurrentPage(1) // Reset to the first page when search term changes
  }, [debouncedSearchTerm])

  // Fetch data when currentPage or searchTerm changes
  useEffect(() => {
    fetchSpecificData(currentPage)
  }, [debouncedSearchTerm, currentPage, limit])

  // Handle pagination
  const handlePageChange = direction => {
    setCurrentPage(prevPage => {
      if (direction === 'next' && prevPage < totalPages) {
        return prevPage + 1
      } else if (direction === 'prev' && prevPage > 1) {
        return prevPage - 1
      }
      return prevPage // No change if out of bounds
    })
  }

  // Handle file upload
  const handleFileChange = e => {
    const file = e.target.files[0]

    if (!file) return

    const fileExtension = file.name.split('.').pop().toLowerCase()
    const binaryMimeTypes = ['application/octet-stream', 'binary/octet-stream']

    // Disallowed binary files by MIME
    if (binaryMimeTypes.includes(file.type)) {
      toast.error('Binary files are not allowed.', {
        position: 'bottom-center'
      })
      return
    }

    // Disallowed binary by extension
    const disallowedExtensions = ['bin', 'exe', 'dll', 'dat']
    if (disallowedExtensions.includes(fileExtension)) {
      toast.error('Binary files are not allowed.', {
        position: 'bottom-center'
      })
      return
    }

    // Only allow .csv and .xlsx
    const acceptedFileTypes = ['.csv', '.xlsx']
    if (!acceptedFileTypes.includes(`.${fileExtension}`)) {
      toast.error('Invalid file type. Please upload a CSV or Excel file.', {
        position: 'bottom-center'
      })
      return
    }

    if (file.size >= maxFileSize) {
      toast.error('File size exceeds 2MB limit.', {
        position: 'bottom-center'
      })
      return
    }

    setSelectedFile(file)
    setValidationReportUrl(null) // Reset on new file
  }

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error('Please select a file first.')
      return
    }

    const allowedTypes = [
      'text/csv',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ]
    if (!allowedTypes.includes(selectedFile.type)) {
      toast.error('Only .csv and .xlsx files are allowed', {
        position: 'bottom-center'
      })
      return
    }

    setUploadProgress(0)

    try {
      setIsUploading(true)
      const response = await uploadCustomDataset(selectedFile, 'kb')

      if (response?.success) {
        if (response.validationResultFile) {
          setValidationReportUrl(response.validationResultFile)
          toast.warning('Validation issues found. Please review the report.')
        } else {
          if (response?.message?.trim()) {
            toast.success(response.message.trim(), {
              position: 'bottom-center'
            })
          }
          setUploadDialogOpen(false)
          fetchSpecificData()
        }
      } else {
        if (!response.success && response.uploadedFile) {
          setValidationReportUrl(response.uploadedFile)
          toast.error(response.message, {
            position: 'bottom-center'
          })
          setUploadDialogOpen(false)
        } else if (response?.message) {
          toast.error(response.message.trim(), {
            position: 'bottom-center'
          })
        }
      }
    } catch (error) {
      console.error('Upload error:', error)
      setIsUploading(false)
    } finally {
      setIsUploading(false)
    }
  }

  const handleRemoveFile = () => {
    setSelectedFile(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handlefilterSubmit = e => {
    console.log(
      'Filter Form Submitted',
      status,
      type,
      dateRange[0],
      dateRange[1],
      fromdate,
      todate
    )

    if (dateRange[0] !== null) {
      if (!dateRange[0]) {
        setError('start dates required.')
        return
      }

      if (!dateRange[1]) {
        setError('end dates required.')
        return
      }
    }
    setError('')

    setonfiltering(true)
    if (dateRange[0] !== null && dateRange[1] !== null) {
      fetchSpecificData()
      console.log('pass')
      handleopenClosedropdown()
    } else {
      if (
        status === '' &&
        type === '' &&
        dateRange[0] === null &&
        dateRange[1] === null
      ) {
        setonfiltering(false)
      } else {
        setonfiltering(true)
        console.log('no pass')
      }

      fetchSpecificData()
      handleopenClosedropdown()
    }
  }

  const handleclearfilter = () => {
    setStatus('')
    setType('')
    setDateRange([null, null])
    setfromdate('')
    settodate('')

    // fetchSpecificData()
    // handleopenClosedropdown()
  }

  // Handle checkbox toggle for selection
  const handleCheckboxChange = id => {
    setSelectedItems(prev => {
      const updatedSelection = { ...prev, [id]: !prev[id] }
      setShowDeleteWarning(
        Object.values(updatedSelection).some(isSelected => isSelected)
      )
      return updatedSelection
    })
  }

  useEffect(() => {
    const count = Object.values(selectedItems).filter(
      isSelected => isSelected
    ).length
    setItemsCount(count)
    setShowDeleteWarning(count > 0)
  }, [selectedItems])

  // Handle deleting multiple items
  const handleYesButtonClick = async () => {
    const idsToDelete = Object.keys(selectedItems).filter(
      id => selectedItems[id]
    )

    if (idsToDelete.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      const deleteResponse = await new GetDataSet().multipleDelete(idsToDelete)

      if (deleteResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after deletion
        toast.success('Items deleted successfully.', {
          position: 'bottom-center'
        })
        setDialogOpen(false)
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error deleting items:', error)
      toast.error('There was an error deleting the item.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const handleopendeletepopup = id => {
    setstoreDelete(id)
    setShowModal(true)
  }

  // Handle deleting a single item
  const handledeletesingledata = async datasetID => {
    try {
      const res = await new GetDataSet().singleDelete(datasetID)

      if (res.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)
        fetchSpecificData() // Refresh data after deletion
        toast.success('Item deleted successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Error deleting the item.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error deleting the item:', error)
      toast.error('There was an error deleting the item.', {
        position: 'bottom-center'
      })
    }
  }

  const handleupdatesingledata = async datasetID => {
    const dataset = new GetDataSet({
      id: datasetID,
      type: 'article'
    })
    const GetUpdateData = await dataset.fetchData()
    console.log(GetUpdateData)

    setupdateDialogopen(true)
    setformDialogopen(true)

    // Initialize metaData with a safe default
    let metaData = {}

    const metaRaw = GetUpdateData.data[0]?.meta

    if (typeof metaRaw === 'string' && metaRaw.trim() !== '') {
      try {
        metaData = validateJSON(metaRaw)
      } catch (parseError) {
        console.error('Error parsing meta JSON:', parseError.message)
        metaData = {}
      }
    } else if (typeof metaRaw === 'object' && metaRaw !== null) {
      metaData = metaRaw
    } else {
      console.warn('Meta is empty or invalid.')
      metaData = {}
    }

    // Determine if it's a content or URL based entry
    const isURL = !!metaData?.data?.url
    const activeTabType = isURL ? 'url' : 'content'
    console.log(isURL, activeTabType)

    setFormData({
      title:
        activeTabType === 'url'
          ? GetUpdateData.data[0].title
          : metaData?.data?.title || '',
      content: metaData?.data?.content || '',
      url: metaData?.data?.url || '',
      sourceType: activeTabType,
      type: 'article',
      status: GetUpdateData.data[0].status,
      id: datasetID
    })

    setActiveTab(activeTabType)
  }

  // Since the backend provides paginated data directly, use `data` as is
  const currentData = data

  // Check if all items on the current page are selected
  const allSelected = currentData.every(item => selectedItems[item.dataset_id])

  // Use the total count from the backend or data.length for the current page
  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = startItem + currentData.length - 1
  totalItems = itemsCount // Use `itemsCount` from the backend's total count

  const handleuntraindataset = async () => {
    const idsToTrain = Object.keys(selectedItems).filter(
      id => selectedItems[id]
    )
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      const untrainResponse = await new GetDataSet().setUntrained(idsToTrain)

      if (untrainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after untrain
        toast.success('Items untrained successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Error untrain items.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error untrain items:', error)
      toast.error('There was an error while processing..', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const handleTrainDataset = async () => {
    const idsToTrain = Object.keys(selectedItems).filter(
      id => selectedItems[id]
    )
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      const trainResponse = await new GetDataSet().setTrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after training
        toast.success('Item processed successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error training items:', error)
      toast.error('There was an error while processing.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const openMessage = () => {
    setDialogOpen(true)
  }

  const handleNoButtonClick = () => {
    setDialogOpen(false)
  }

  const handleformdialogbox = () => {
    setformDialogopen(true)
    setFormData({
      title: '',
      content: ''
    })
  }

  // const handleSaveAndTrain = async () => {
  //   try {
  //     const titleEmpty = !formData.title || formData.title.trim() === ''
  //     const contentEmpty = !formData.content || formData.content.trim() === ''
  //     const urlEmpty = !formData.url || formData.url.trim() === ''

  //     const isValidUrl = url => {
  //       const pattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i
  //       return pattern.test(url)
  //     }

  //     // Validation for content tab
  //     if (activeTab === 'content') {
  //       if (titleEmpty && contentEmpty) {
  //         toast.error('Title and Content are required', {
  //           position: 'bottom-center'
  //         })
  //         return
  //       }
  //       if (titleEmpty) {
  //         toast.error('Title is required', { position: 'bottom-center' })
  //         return
  //       }
  //       if (contentEmpty) {
  //         toast.error('Content is required', { position: 'bottom-center' })
  //         return
  //       }
  //     }

  //     // Validation for url tab
  //     if (activeTab === 'url') {
  //       if (titleEmpty && urlEmpty) {
  //         toast.error('Title and URL are required', {
  //           position: 'bottom-center'
  //         })
  //         return
  //       }
  //       if (titleEmpty) {
  //         toast.error('Title is required', { position: 'bottom-center' })
  //         return
  //       }
  //       if (urlEmpty) {
  //         toast.error('URL is required', { position: 'bottom-center' })
  //         return
  //       }
  //       if (!isValidUrl(formData.url.trim())) {
  //         toast.error('Valid URL is required', { position: 'bottom-center' })
  //         return
  //       }
  //     }

  //     const metaData =
  //       activeTab === 'content'
  //         ? { content: formData.content }
  //         : { url: formData.url }

  //     const data = [
  //       {
  //         title: formData.title,
  //         type: 'article',
  //         status: 'inactive',
  //         store_id: storeid,
  //         meta: { data: { title: formData.title, ...metaData } },
  //         training_processing: false
  //       }
  //     ]

  //     const res = await insertdataset(data)

  //     // ✅ Handle duplicate case
  //     if (res?.data?.datasets?.failed?.length > 0) {
  //       const failMsg =
  //         res.data.datasets.failed[0].message || 'Dataset creation failed'
  //       toast.error(failMsg, { position: 'bottom-center' })
  //       return
  //     }

  //     if (res.success && res?.data?.datasets?.success?.length > 0) {
  //       const datasetid = res.data.datasets.success[0].dataset_id

  //       toast.warning('Dataset is being created and training in process...', {
  //         position: 'bottom-center'
  //       })

  //       if (res.data.datasets.success[0].status === 'inactive') {
  //         await new GetDataSet().setTrained([datasetid])
  //         fetchSpecificData()
  //       }

  //       setformDialogopen(false)
  //       toast.success('Dataset created and training is finished', {
  //         position: 'bottom-center'
  //       })

  //       setFormData({ title: '', content: '', url: '', sourceType: 'content' })
  //       setActiveTab('content')

  //       window.dispatchEvent(
  //         new CustomEvent('datasetDeleted', { detail: true })
  //       )
  //     }
  //   } catch (error) {
  //     console.error('Error:', error)
  //   }
  // }

  const handleinsertform = async e => {
    e.preventDefault()

    const titleEmpty = !formData.title || formData.title.trim() === ''
    const contentEmpty = !formData.content || formData.content.trim() === ''
    const urlEmpty = !formData.url || formData.url.trim() === ''

    const isValidUrl = url => {
      const pattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i
      return pattern.test(url)
    }

    // Validation (same as before) ...
    if (activeTab === 'content') {
      if (titleEmpty && contentEmpty) {
        toast.error('Title and Content are required', {
          position: 'bottom-center'
        })
        return
      }
      if (titleEmpty) {
        toast.error('Title is required', { position: 'bottom-center' })
        return
      }
      if (contentEmpty) {
        toast.error('Content is required', { position: 'bottom-center' })
        return
      }
    }

    if (activeTab === 'url') {
      if (titleEmpty && urlEmpty) {
        toast.error('Title and URL are required', { position: 'bottom-center' })
        return
      }
      if (titleEmpty) {
        toast.error('Title is required', { position: 'bottom-center' })
        return
      }
      if (urlEmpty) {
        toast.error('URL is required', { position: 'bottom-center' })
        return
      }
      if (!isValidUrl(formData.url.trim())) {
        toast.error('Valid URL is required', { position: 'bottom-center' })
        return
      }
    }

    const metaData =
      activeTab === 'content'
        ? { content: formData.content }
        : { url: formData.url }

    const data = [
      {
        title: formData.title,
        type: 'article',
        status: 'inactive',
        store_id: storeid,
        meta: { data: { title: formData.title, ...metaData } },
        training_processing: false
      }
    ]

    try {
      const res = await insertdataset(data)

      // ✅ Handle duplicate case
      if (res?.data?.datasets?.failed?.length > 0) {
        const failMsg =
          res.data.datasets.failed[0].message || 'Dataset creation failed'
        toast.error(failMsg, { position: 'bottom-center' })
        return
      }

      if (res.success && res?.data?.datasets?.success?.length > 0) {
        const datasetid = res.data.datasets.success[0].dataset_id

        toast.warning('Training is in process, please wait', {
          position: 'bottom-center'
        })

        if (res.data.datasets.success[0].status === 'inactive') {
          await new GetDataSet().setTrained([datasetid])
          fetchSpecificData()
          setformDialogopen(false)
          toast.success('Dataset is created successfully', {
            position: 'bottom-center'
          })
        } else {
          setformDialogopen(false)
          toast.success('Dataset is created successfully', {
            position: 'bottom-center'
          })
        }

        setFormData({ title: '', content: '', url: '', sourceType: 'content' })
        setActiveTab('content')

        window.dispatchEvent(
          new CustomEvent('datasetDeleted', { detail: true })
        )
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleupdatedata = async e => {
    e.preventDefault()

    const updatedataset = new GetDataSet()
    const metaValue =
      formData.sourceType === 'content' ? formData.content : formData.url

    // console.log(formData)
    // console.log(metaValue)
    console.log(formData.sourceType)
    await updatedataset
      .updateMetaTitle(
        formData.id,
        formData.title,
        metaValue,
        formData.type,
        formData.sourceType
      )
      .then(async res => {
        if (res.success) {
          toast.warning('Training In-Progress. Please wait', {
            position: 'bottom-center'
          })
          if (formData.status === 'active') {
            const trainResponse = await new GetDataSet().setTrained([
              formData.id
            ])

            if (trainResponse.success) {
              toast.success('Dataset updated successfully.', {
                position: 'bottom-center'
              })
            } else {
              toast.warning('Updated, but training failed.', {
                position: 'bottom-center'
              })
            }
          } else {
            toast.success('Item updated successfully.', {
              position: 'bottom-center'
            })
          }
          setupdateDialogopen(false)
          setformDialogopen(false)
          fetchSpecificData()
        }
      })
      .catch(error => {
        console.error('Error:', error)
        toast.error('Update failed.', {
          position: 'bottom-center'
        })
      })
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value // Update the corresponding field
    })
  }

  const handleuntraindatasetflashoff = async id => {
    const idsToTrain = [id]
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      const trainResponse = await new GetDataSet().setUntrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after training
        toast.success('Items untrained successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error training items:', error)
      toast.error('There was an error while processing.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const handleuntraindatasetflashon = async id => {
    const idsToTrain = [id]
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      const trainResponse = await new GetDataSet().setTrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)
        localStorage.removeItem('shopifySession')
        fetchSpecificData(currentPage) // Refresh data after training
        toast.success('Item processed successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error training items:', error)
      toast.error(error.message, {
        position: 'bottom-center'
      })
      // handleinstall(error, idsToTrain)
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  return (
    <>
      {showModal && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] h-[240px] mx-5 p-6 border-[1.6px] border-[#FFFFFF]  shadow[-1px_0px_0px_0px_inset]'>
            <div className='block'>
              <div className='w-full flex justify-end items-start '>
                <svg
                  onClick={() => {
                    setShowModal(false)
                  }}
                  width='26'
                  height='26'
                  className='cursor-pointer'
                  viewBox='0 0 26 26'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
                    fill='#373737'
                  />
                </svg>
              </div>
              <div className=' mt-2 flex flex-col items-center justify-center gap-3'>
                <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
                  Delete
                </p>
                <p className='font-[400] text-[16px] leading-[21px] text-center'>
                  Are you sure want to delete?
                </p>
                <div className='flex mt-4 gap-4'>
                  <button
                    onClick={() => {
                      setShowModal(false)
                    }}
                    className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      handledeletesingledata(storeDelete)
                      setstoreDelete('')
                      setShowModal(false)
                    }}
                    className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {validationReportUrl && (
        <div className='relative mb-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200'>
          {/* Close Button */}
          <button
            onClick={async () => {
              const urlParts = validationReportUrl.split('/')
              const filename = urlParts[urlParts.length - 1]
              await deleteUploadedFile(filename)
              setValidationReportUrl(null)
            }}
            className='absolute top-2 right-2 text-yellow-700 hover:text-yellow-900 text-lg font-bold'
            aria-label='Close'
          >
            ×
          </button>

          {/* Content */}
          <h3 className='text-sm font-semibold text-yellow-700 mb-2'>
            Validation Issues Found
          </h3>
          <a
            href={validationReportUrl}
            onClick={async () => {
              const urlParts = validationReportUrl.split('/')
              const filename = urlParts[urlParts.length - 1]
              await deleteUploadedFile(filename)
              setValidationReportUrl(null)
            }}
            download='validation_result.xlsx'
            target='_blank'
            rel='noopener noreferrer'
            className='text-yellow-700 underline flex gap-1 items-center hover:text-yellow-900 text-sm'
          >
            <IonIcon name='download-outline' />
            Download Validation Report
          </a>
          <p className='mt-1 text-xs text-yellow-600'>
            Click above to review rows with issues. This file will be
            auto-deleted.
          </p>
        </div>
      )}

      {uploadDialogOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
          <div className='bg-white rounded-lg p-6 w-full max-w-md'>
            <div className='flex justify-between items-center mb-4'>
              <h2 className='text-xl font-bold'>Upload Custom Dataset</h2>
              <button
                onClick={() => {
                  setUploadDialogOpen(false)
                  handleRemoveFile()
                }}
                className='text-gray-500 hover:text-gray-700'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            {/* File Upload Section */}
            <div className='mb-6'>
              <label className='block text-sm font-medium text-gray-700 mb-2'>
                Upload your dataset
              </label>
              <div className='flex items-center'>
                <label className='flex flex-col items-center px-4 py-6 bg-white rounded-lg border border-dashed border-gray-300 cursor-pointer hover:bg-gray-50'>
                  <input
                    type='file'
                    ref={fileInputRef}
                    className='hidden'
                    accept='.csv,.xlsx'
                    onChange={handleFileChange}
                    disabled={isUploading}
                  />
                  <span className='text-sm text-gray-600'>
                    {selectedFile
                      ? selectedFile.name
                      : 'Choose CSV or Excel file (max 2MB)'}
                  </span>
                </label>
                {selectedFile && (
                  <button
                    onClick={handleRemoveFile}
                    className='ml-2 text-red-500 hover:text-red-700'
                    disabled={isUploading}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}
              </div>
              <p className='mt-1 text-xs text-gray-500'>
                Accepted formats: .csv, .xlsx (max 2MB)
              </p>

              <p className='mt-1 text-xs text-red-500'>
                Note: Please provide either content or URL, but not both for a
                given entry.
              </p>
            </div>

            <div className='mb-6 p-4 bg-gray-50 rounded-lg'>
              <h3 className='text-sm font-medium text-gray-700 mb-2'>
                Need help formatting your data?
              </h3>
              <a
                href='/kb.xlsx'
                download='sample_dataset_template.xlsx'
                className='text-blue-600 hover:text-blue-800 text-sm flex items-center'
              >
                <FontAwesomeIcon icon={faDownload} className='mr-2' />
                Download Sample Template
              </a>
              <p className='mt-1 text-xs text-gray-500'>
                You can download a sample data file here for reference.
              </p>
            </div>

            {/* Validation Report Section
            {validationReportUrl && (
              <div className='mb-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200'>
                <h3 className='text-sm font-medium text-yellow-700 mb-2'>
                  Validation Issues Found
                </h3>
                <button
                  onClick={handleDownloadReport}
                  className='text-yellow-700 hover:text-yellow-800 text-sm flex items-center'
                >
                  <FontAwesomeIcon icon={faDownload} className='mr-2' />
                  Download Validation Report
                </button>
                <p className='mt-1 text-xs text-yellow-600'>
                  You can view the full details for each row by downloading the
                  data file.
                </p>
              </div>
            )} */}

            {/* Progress Bar */}
            {isUploading && (
              <div className='w-full bg-gray-200 rounded-full h-2.5 mb-4'>
                <div
                  className='bg-blue-600 h-2.5 rounded-full'
                  style={{ width: `${uploadProgress}%` }}
                ></div>
              </div>
            )}

            {/* Action Buttons */}
            <div className='flex justify-end space-x-3'>
              <button
                onClick={() => {
                  setUploadDialogOpen(false)
                  handleRemoveFile()
                }}
                className='px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200'
                disabled={isUploading}
              >
                Cancel
              </button>
              <button
                onClick={handleUpload}
                className='mt-4 md:mt-0 px-4 py-2 bg-[#7C50DD] w-full md:w-[140px] flex justify-center items-center text-white rounded-full text-[14px]'
                disabled={isUploading || !selectedFile}
              >
                {isUploading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
        </div>
      )}
      {formDialogopen && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#FFFFFF] shadow-lg w-full max-w-[900px] mx-auto my-[30px] rounded-[24px] border-[1.6px] border-white overflow-y-auto min-h-[40%] max-h-[90%] scrollbar-hide'>
            {/* HEAD */}
            <div className='flex justify-between items-center px-7 py-4 border-b mb-2'>
              <div className='flex flex-col gap-1 w-full'>
                <div className='flex justify-between items-center'>
                  <h1 className='font-extrabold text-[25px]'>
                    {updateDialogopen
                      ? 'Update Your Knowledge Base'
                      : 'Create Your Knowledge Base'}
                  </h1>
                  <button
                    onClick={() => {
                      setformDialogopen(false)
                      setupdateDialogopen(false)
                      setActiveTab('content')
                    }}
                    className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px] text-[14px] sm:text-[18px] cursor-pointer'
                  >
                    <svg
                      width='30'
                      height='30'
                      viewBox='0 0 30 30'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M9.10041 7.77459C8.7343 7.40847 8.1407 7.40847 7.77459 7.77459C7.40847 8.1407 7.40847 8.7343 7.77459 9.10041L13.6742 15L7.77459 20.8996C7.40847 21.2657 7.40847 21.8593 7.77459 22.2254C8.1407 22.5915 8.7343 22.5915 9.10041 22.2254L15 16.3258L20.8996 22.2254C21.2657 22.5915 21.8593 22.5915 22.2254 22.2254C22.5915 21.8593 22.5915 21.2657 22.2254 20.8996L16.3258 15L22.2254 9.10041C22.5915 8.7343 22.5915 8.1407 22.2254 7.77459C21.8593 7.40847 21.2657 7.40847 20.8996 7.77459L15 13.6742L9.10041 7.77459Z'
                        fill='#373737'
                      />
                    </svg>
                  </button>
                </div>
                <p className='text-[12px] text-gray-600 mt-2'>
                  Have a question or need assistance? Fill out the contact form,
                  and our support team will get back to you as soon as possible.
                  <br />
                  <span className='font-medium text-[#FF5252]'>
                    Please don’t include anything private or sensitive.
                  </span>
                </p>
              </div>
            </div>

            {/* TABS */}
            {/* TABS */}
            <div className='px-7 border-b'>
              <div className='flex gap-6 -mt-2'>
                {(!updateDialogopen || formData.sourceType === 'content') && (
                  <button
                    className={`py-3 font-medium text-sm border-b-2 transition-all ${
                      activeTab === 'content'
                        ? 'border-[#7C50DD] text-[#7C50DD]'
                        : 'border-transparent text-gray-500'
                    }`}
                    onClick={() => {
                      !updateDialogopen && setActiveTab('content')
                      setFormData({
                        title: '',
                        content: '',
                        url: '',
                        sourceType: 'content'
                      })
                    }}
                  >
                    📄 Content
                  </button>
                )}
                {(!updateDialogopen || formData.sourceType === 'url') && (
                  <button
                    className={`py-3 font-medium text-sm border-b-2 transition-all ${
                      activeTab === 'url'
                        ? 'border-[#7C50DD] text-[#7C50DD]'
                        : 'border-transparent text-gray-500'
                    }`}
                    onClick={() => {
                      !updateDialogopen && setActiveTab('url')
                      setFormData({
                        title: '',
                        content: '',
                        url: '',
                        sourceType: 'content'
                      })
                    }}
                  >
                    🔗 URL
                  </button>
                )}
              </div>
            </div>

            {/* FORM */}
            <form
              onSubmit={updateDialogopen ? handleupdatedata : handleinsertform}
            >
              <div className='px-4 py-2'>
                {activeTab === 'content' && (
                  <>
                    {/* Title */}
                    <div className='w-full mt-2'>
                      <label className='block mb-1 ml-2  text-gray-700'>
                        Title <span className='text-red-500'>*</span>
                      </label>
                      <input
                        type='text'
                        name='title'
                        className='bg-[#F8F7F7] focus:outline-none w-full h-[55px] rounded-[24px] p-3'
                        placeholder='Title'
                        value={formData.title}
                        onChange={handleInputChange}
                        maxLength={200}
                      />
                      <small
                        className={`block mt-1 ml-2 ${
                          formData.title.length >= 200
                            ? 'text-red-500'
                            : 'text-gray-500'
                        }`}
                      >
                        {formData.title.length}/200 characters
                      </small>
                    </div>

                    {/* Content */}
                    <div className='w-full mt-3'>
                      <label className='block mb-1 text-gray-700 ml-2'>
                        Content <span className='text-red-500'>*</span>
                      </label>
                      <div className='relative'>
                        <MDXEditor
                          markdown={formData.content || ''} // initial value only
                          onChange={value => {
                            // no manual slicing; plugin enforces the limit
                            setFormData(prev => ({ ...prev, content: value }))
                          }}
                          placeholder='Enter the content (max 2000 characters)'
                          className='bg-[#F8F7F7] only-bottom-rounded focus:outline-none w-full min-h-[180px] max-h-[400px] overflow-auto pb-[60px] mdx-editor-custom'
                          plugins={[
                            headingsPlugin(),
                            listsPlugin(),
                            linkPlugin(),
                            linkDialogPlugin(),
                            quotePlugin(),
                            thematicBreakPlugin(),
                            markdownShortcutPlugin(),
                            toolbarPlugin({
                              toolbarContents: () => (
                                <>
                                  <BoldItalicUnderlineToggles />
                                  <CreateLink />
                                </>
                              )
                            }),
                            maxLengthPlugin(2000)
                          ]}
                        />

                        <div
                          className={`absolute bottom-3 right-3 text-xs px-2 py-1 rounded border font-medium ${
                            (formData.content?.length || 0) >= 2000
                              ? 'bg-red-100 text-red-800 border-red-300'
                              : (formData.content?.length || 0) > 1800
                              ? 'bg-yellow-100 text-yellow-800 border-yellow-300'
                              : 'bg-white text-gray-500 border-gray-300'
                          }`}
                        >
                          {formData.content?.length || 0}/2000 characters
                        </div>
                      </div>
                      <small
                        className={`block mt-1 ${
                          (formData.content?.length || 0) >= 2000
                            ? 'text-red-500'
                            : 'text-gray-500'
                        }`}
                      >
                        {formData.content?.length || 0}/2000 characters
                      </small>
                    </div>
                  </>
                )}

                {activeTab === 'url' && (
                  <div className='w-full mt-3 flex flex-col gap-2'>
                    {/* Title */}
                    <div>
                      <label className='block mb-1 ml-2 text-gray-700'>
                        Title <span className='text-red-500'>*</span>
                      </label>
                      <input
                        type='text'
                        name='title'
                        className='bg-[#F8F7F7] focus:outline-none w-full h-[55px] rounded-[24px] p-3'
                        placeholder='Title'
                        value={formData.title}
                        onChange={handleInputChange}
                        maxLength={200}
                      />
                      <small
                        className={`block mt-1 ml-2 ${
                          formData.title.length >= 200
                            ? 'text-red-500'
                            : 'text-gray-500'
                        }`}
                      >
                        {formData.title.length}/200 characters
                      </small>
                    </div>

                    {/* URL */}
                    <div>
                      <label className='block ml-2 mb-1 text-gray-700'>
                        URL <span className='text-red-500'>*</span>
                      </label>
                      <input
                        type='text'
                        name='url'
                        className='bg-[#F8F7F7] focus:outline-none w-full h-[55px] rounded-[24px] p-3'
                        placeholder='Enter the URL'
                        value={formData.url || ''}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* BOTTOM BUTTON */}
              <div className='flex justify-end mt-5 p-4 border-t gap-3'>
                {/* Save / Update */}
                <button
                  type='submit'
                  className='bg-[#7C50DD] text-white py-2 px-10 text-[14px] rounded-[19px]'
                >
                  {updateDialogopen ? 'Update' : 'Save'}
                </button>

                {/* Save & Train */}
                {/* {!updateDialogopen && (
                  <button
                    type='button'
                    className='bg-[#7C50DD] text-white py-2 px-10 text-[14px] rounded-[19px]'
                    onClick={() => handleSaveAndTrain()}
                  >
                    Save & Train
                  </button>
                )} */}
              </div>
            </form>
          </div>
        </div>
      )}

      {dialogOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] mx-5 h-[240px] p-6 border-[1.6px] border-[#FFFFFF]  shadow[-1px_0px_0px_0px_inset]'>
            <div className='block'>
              <div className='w-full flex justify-end items-start z-50'>
                <svg
                  onClick={handleNoButtonClick}
                  width='26'
                  height='26'
                  className='cursor-pointer'
                  viewBox='0 0 26 26'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
                    fill='#373737'
                  />
                </svg>
              </div>
              <div className=' mt-2 flex flex-col items-center justify-center gap-3 z-[1000]'>
                <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
                  Delete
                </p>
                <p className='font-[400] text-[16px] leading-[21px]'>
                  Do you want to delete selected items?
                </p>
                <div className='flex mt-4 gap-4'>
                  <button
                    onClick={handleNoButtonClick}
                    className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleYesButtonClick}
                    className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className=' gap-2  overflow-x-auto md:overflow-x-visible scrollbar-hide md:flex  block  justify-between border-b-[1px] pt-7 pl-3 pr-3 pb-7'>
        <div className='block w-full'>
          <div className='flex items-center gap-1'>
            <h2 className='font-bold text-[18px]  cursor-pointer'>
              {' '}
              Knowledge Base
            </h2>
            <InfoIconWithToolTip
              content={
                "Add documents or custom knowledge that isn't on your website to expand your bot’s understanding and provide more complete responses."
              }
            />
          </div>

          <span className='font-[500] text-[14px] leading-[24px] pr-5'>
            Dataset ({totalproducts})
          </span>
        </div>
        <div className='flex flex-col mt-2 gap-3 lg:flex-row items-center  justify-end  w-full '>
          <div className=' w-full flex gap-3 justify-end items-center'>
            <div className=''>
              <div className=' w-full Filter'>
                <button
                  // data-tooltip-id={'my-tooltip'}
                  // data-tooltip-content={'filter'}
                  // data-tooltip-place={'top'}
                  onClick={event => {
                    createRipple(event)
                    handleopenClosedropdown()
                  }}
                  className={` bg-[#f4f4f4] py-[11px] px-[11px] rounded-[8px] border-[0.5px] cursor-pointer 
      hover:bg-gray-200 transition-all  ${isopenpopup && 'bg-gray-200'}`}
                >
                  <TfiFilter size={16} />
                  {ripple.map(({ x, y, id }) => (
                    <span
                      key={id}
                      className='absolute block bg-white opacity-100 rounded-full animate-ripple'
                      style={{
                        top: y,
                        left: x,
                        width: '20px',
                        height: '20px',
                        transform: 'translate(50%, 50%)'
                      }}
                    ></span>
                  ))}
                </button>
                {onfiltering && (
                  <span className=' absolute right-[0.1px] top-[-1px] bg-green-400 w-2 h-2 rounded'></span>
                )}
              </div>
              {isopenpopup && (
                <TrainFilterDropdownPopup
                  isopenpopup={closefilterpopup}
                  clearbtn={handleclearfilter}
                  fields={[
                    // Custom Dropdown
                    <div className='flex relative w-full'>
                      <div className='flex flex-col w-full justify-start'>
                        <p className='text-[#7A7D9C] text-[14px] mb-1'>
                          Status
                        </p>
                        <select
                          name='status'
                          value={status}
                          onChange={e => {
                            setStatus(e.target.value)
                          }}
                          className='w-full cursor-pointer border-[1px] border-[#BFC4D7] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none appearance-none '
                        >
                          <option value=''>---</option>
                          <option value='active'>Trained</option>
                          <option value='inactive'>UnTrained</option>
                        </select>
                        <IonIcon
                          name='chevron-down'
                          className='absolute right-2 top-[58%] text-gray-500 cursor-pointer pointer-events-none'
                        />
                      </div>
                    </div>,
                    // Custom Date Picker
                    <div className='relative flex cursor-pointer w-full'>
                      <div className='flex flex-col w-full justify-start'>
                        <p className='text-[#7A7D9C] text-[14px] mb-1'>
                          Date Range
                        </p>
                        <DatePicker
                          ref={datepickerref}
                          selected={startDate}
                          onChange={update => setDateRange(update)}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          dateFormat='yyyy-MM-dd'
                          name='daterange'
                          autoComplete='off'
                          className='w-full border-[1px] border-[#BFC4D7] placeholder:text-[#ABADB5] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none'
                        />
                        {error && (
                          <p className='text-red-500 text-sm absolute bottom-[-18px]'>
                            {error}
                          </p>
                        )}
                      </div>
                      <IonIcon
                        name='calendar-outline'
                        className='absolute right-2 top-[58%] text-gray-500 cursor-pointer '
                        onClick={() => datepickerref.current.setOpen(true)} // Open DatePicker programmatically
                      />
                    </div>
                  ]}
                  onsubmit={handlefilterSubmit}
                />
              )}
            </div>
            <div className='flex  items-center w-[194px] h-[41px] rounded-[39px] border border-[#ccc] bg-[#F4F4F4] px-4 gap-2'>
              <input
                type='text'
                className='bg-transparent focus:outline-none flex placeholder:text-[#565656] placeholder:text-[12px] text-[14px]'
                placeholder='Search here'
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              <svg
                className={`cursor-pointer  ${
                  formDialogopen === true ? '' : 'scale-[4]'
                }`}
                viewBox='0 0 16 15'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M15.0555 13.3145L11.7477 10.0066C12.544 8.94645 12.9739 7.65598 12.9725 6.33C12.9725 2.94305 10.217 0.1875 6.83 0.1875C3.44305 0.1875 0.6875 2.94305 0.6875 6.33C0.6875 9.71695 3.44305 12.4725 6.83 12.4725C8.15598 12.4739 9.44645 12.044 10.5066 11.2477L13.8145 14.5555C13.9819 14.7052 14.2003 14.7851 14.4248 14.7788C14.6493 14.7725 14.8629 14.6805 15.0217 14.5217C15.1805 14.3629 15.2725 14.1493 15.2788 13.9248C15.2851 13.7003 15.2052 13.4819 15.0555 13.3145ZM2.4425 6.33C2.4425 5.46223 2.69982 4.61396 3.18193 3.89244C3.66403 3.17092 4.34927 2.60856 5.15098 2.27648C5.95269 1.9444 6.83487 1.85751 7.68596 2.0268C8.53705 2.1961 9.31883 2.61397 9.93243 3.22757C10.546 3.84117 10.9639 4.62295 11.1332 5.47404C11.3025 6.32513 11.2156 7.20731 10.8835 8.00902C10.5514 8.81073 9.98909 9.49597 9.26756 9.97807C8.54604 10.4602 7.69777 10.7175 6.83 10.7175C5.66679 10.7161 4.55162 10.2534 3.72911 9.43089C2.9066 8.60838 2.4439 7.49321 2.4425 6.33Z'
                  fill='#0F062C'
                  fillOpacity='0.7'
                />
              </svg>
            </div>
          </div>
          <button
            onClick={() => setUploadDialogOpen(true)}
            className='mt-4 md:mt-0 px-4 py-2 upload-button bg-[#7C50DD] w-full lg:w-[140px] flex justify-center items-center text-white rounded-full text-[14px]'
          >
            <span className='text-[15px] font-[700] mr-1 flex items-center'>
              <IonIcon name='arrow-up-outline' />
            </span>
            <p className='text-[12px] font-[700] leading-5'>Upload</p>
          </button>

          <button
            onClick={handleformdialogbox}
            className='mt-4 md:mt-0  px-4 py-2 createbtn bg-[#7C50DD] w-full lg:w-[140px] flex justify-center items-center text-white rounded-full text-[14px]'
          >
            <span className='text-[15px] mr-1 font-[700]'>+</span>
            <p className='mr-2 text-[12px] font-[700] leading-5'>Create</p>
          </button>
        </div>
      </div>
      {showDeleteWarning && (
        <div
          className={`transition-all duration-500 ease-in-out transform overflow-x-auto ${
            showDeleteWarning
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 -translate-y-4'
          } flex justify-between pt-2 pb-2 bg-[#232328] items-center pl-3 pr-3 border-b-[1px]`}
        >
          <div className='flex'>
            <div className='w-[195px] h-[35px] flex items-center text-white rounded-[8px]'>
              <FontAwesomeIcon
                icon={faCheck}
                className='text-white mr-2 text-[12px]'
              />
              <span className='text-[12px] font-semibold'>{itemsCount}</span>
              <p className='text-[12px] font-semibold ml-2'>selected items</p>
            </div>
          </div>
          <div className='flex gap-4 items-center'>
            <div
              onClick={openMessage}
              className='w-[32px] h-[32px] flex items-center justify-center bg-red-600 rounded-[8px] cursor-pointer'
            >
              <svg
                width='32'
                height='33'
                viewBox='0 0 34 35'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M15.7485 11.5C15.7159 11.4999 15.6835 11.5063 15.6533 11.5187C15.6231 11.5312 15.5957 11.5495 15.5726 11.5726C15.5495 11.5957 15.5312 11.6231 15.5187 11.6533C15.5063 11.6835 15.4999 11.7159 15.5 11.7485L15.5 11.75V12.5H18.5V11.75L18.5 11.7485C18.5001 11.7159 18.4937 11.6835 18.4813 11.6533C18.4688 11.6231 18.4505 11.5957 18.4274 11.5726C18.4043 11.5495 18.3769 11.5312 18.3467 11.5187C18.3165 11.5063 18.2841 11.4999 18.2515 11.5L18.25 11.5H15.75L15.7485 11.5ZM13.0322 13.5L13.624 22.9688C13.6241 22.9707 13.6242 22.9725 13.6243 22.9743C13.6416 23.3108 13.865 23.5 14.125 23.5H19.875C20.1324 23.5 20.3548 23.3151 20.3759 22.9695L20.9678 13.5H13.0322ZM21.4954 12.5H19.5V11.7507C19.5004 11.5865 19.4683 11.4238 19.4057 11.272C19.343 11.1199 19.2508 10.9818 19.1345 10.8655C19.0182 10.7492 18.8801 10.657 18.728 10.5943C18.5762 10.5317 18.4136 10.4996 18.2494 10.5H15.7506C15.5864 10.4996 15.4238 10.5317 15.272 10.5943C15.1199 10.657 14.9818 10.7492 14.8655 10.8655C14.7492 10.9818 14.657 11.1199 14.5943 11.272C14.5317 11.4238 14.4996 11.5864 14.5 11.7506V12.5H12.5046C12.5019 12.5 12.4991 12.5 12.4963 12.5H11.5C11.2239 12.5 11 12.7239 11 13C11 13.2761 11.2239 13.5 11.5 13.5H12.0303L12.6258 23.0287C12.6693 23.8464 13.286 24.5 14.125 24.5H19.875C20.722 24.5 21.3245 23.8406 21.3741 23.0306C21.3741 23.0306 21.3741 23.0305 21.3741 23.0305L21.9697 13.5H22.5C22.7761 13.5 23 13.2761 23 13C23 12.7239 22.7761 12.5 22.5 12.5H21.5037C21.5009 12.5 21.4981 12.5 21.4954 12.5ZM14.7322 14.5003C15.0081 14.4905 15.2398 14.7062 15.2497 14.9822L15.4997 21.9822C15.5095 22.2581 15.2938 22.4898 15.0178 22.4997C14.7419 22.5095 14.5102 22.2938 14.5003 22.0178L14.2503 15.0178C14.2405 14.7419 14.4562 14.5102 14.7322 14.5003ZM19.2678 14.5003C19.5438 14.5102 19.7595 14.7419 19.7497 15.0178L19.4997 22.0178C19.4898 22.2938 19.2581 22.5095 18.9822 22.4997C18.7062 22.4898 18.4905 22.2581 18.5003 21.9822L18.7503 14.9822C18.7602 14.7062 18.9919 14.4905 19.2678 14.5003ZM17 14.5C17.2761 14.5 17.5 14.7239 17.5 15V22C17.5 22.2761 17.2761 22.5 17 22.5C16.7239 22.5 16.5 22.2761 16.5 22V15C16.5 14.7239 16.7239 14.5 17 14.5Z'
                  fill='#FFF'
                />
              </svg>
            </div>
            <div className='flex justify-center items-center gap-2'>
              <button
                data-tooltip-id={'my-tooltip'}
                data-tooltip-content={
                  'These are the data items that have already been used to teach or fine-tune the AI. The AI can understand and answer questions about them.'
                }
                data-tooltip-place={'top'}
                onClick={handleTrainDataset}
                className='hover:bg-[#7C50DD] bg-white w-[69px] rounded-[5px] h-[29px] font-[600] text-[11.5px] text-black hover:text-white'
              >
                Train
              </button>
              <button
                data-tooltip-id={'my-tooltip'}
                data-tooltip-content={
                  'These are the data items that haven’t been used by the AI yet. They exist in the system but the AI doesn’t “know” them.'
                }
                data-tooltip-place={'top'}
                onClick={handleuntraindataset}
                className='hover:bg-[#7C50DD] bg-white w-[69px] rounded-[5px] h-[29px] font-[600] text-[11.5px] text-black hover:text-white'
              >
                UnTrain
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Table */}
      <div className=''>
        <div className='overflow-x-auto'>
          <table className='min-w-full table-auto'>
            <thead>
              <tr className='border-b-[1px]'>
                <th className='border-none p-3 text-left font-extrabold text-[14px] leading-[24px] '>
                  <div className='flex justify-start items-center'>
                    <input
                      type='checkbox'
                      className='mr-2  border-2 border-[#7C50DD] rounded cursor-pointer checked:bg-[#7C50DD] checked:border-[#7C50DD] focus:outline-none'
                      onChange={() => {
                        const newSelectedItems = currentData.reduce(
                          (acc, item) => {
                            acc[item.dataset_id] = !allSelected
                            return acc
                          },
                          {}
                        )
                        setSelectedItems(prevSelectedItems => ({
                          ...prevSelectedItems,
                          ...newSelectedItems
                        }))
                        setShowDeleteWarning(!allSelected)
                      }}
                      checked={allSelected}
                    />
                    Title
                  </div>
                </th>
                <th className='border-none  p-3 text-left font-extrabold text-[14px] leading-[24px]'>
                  <p className='createddate inline-flex'>Created Date</p>
                </th>
                <th className='border-none  p-3 text-left font-extrabold text-[14px] leading-[24px]'>
                  <p className='status inline-flex'>Status</p>
                </th>
                <th className='border-none p-3 text-left font-extrabold text-[14px] leading-[24px]'>
                  <p className='action inline-flex'>Action</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan='4' className='text-center py-4'>
                    No data available
                  </td>
                </tr>
              ) : (
                currentData.map(item => (
                  <tr key={item.dataset_id} className='border-b-[1px]'>
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32] max-w-[490px]'>
                      <div className='flex justify-start items-center'>
                        <input
                          type='checkbox'
                          className='mr-2 '
                          checked={selectedItems[item.dataset_id] || false}
                          onChange={() => handleCheckboxChange(item.dataset_id)}
                        />
                        <p className='mt-[0.4%]'>
                          {(() => {
                            try {
                              const metaUrl = JSON.parse(item.meta)?.data?.url
                              return metaUrl ? '🔗 ' : ''
                            } catch {
                              return ''
                            }
                          })()}
                          {item.title}
                        </p>
                      </div>
                    </td>
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32]'>
                      {new Date(item.createdAt).toLocaleString('en-US', {
                        timeZone: 'UTC'
                      })}
                    </td>
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32]'>
                      {item.status === 'active' ? (
                        <div className=' inline-flex items-center h-[24px]  pt-[2px] pr-[8px] pb-[2px] pl-[8px] bg-[#F0FAF0] rounded-[5px] '>
                          <div className='w-[4px] h-[4px] bg-[#2D8A39] rounded-[100%]'></div>
                          <p className='ml-1 font-[400] text-[11.5px]  text-[#2D8A39]'>
                            Trained
                          </p>
                        </div>
                      ) : (
                        <div className=' inline-flex items-center h-[24px]  pt-[2px] pr-[8px] pb-[2px] pl-[8px] bg-[#FFF8EB] rounded-[5px] '>
                          <div className='w-[4px] h-[4px] bg-[#EEA23E] rounded-[100%]'></div>
                          <p className='ml-1 font-[400] text-[11.5px]  text-[#000000]'>
                            UnTrained
                          </p>
                        </div>
                      )}
                    </td>
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32]'>
                      {/* <button className="text-blue-500">
                                            <svg width="25" height="26" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="17" cy="17.5" r="16.5" fill="#EDEDED" stroke="#DED6D6" />
                                                <path d="M17 22.8334H23M20 11.8334C20.2652 11.5682 20.6249 11.4192 21 11.4192C21.1857 11.4192 21.3696 11.4558 21.5412 11.5268C21.7128 11.5979 21.8687 11.7021 22 11.8334C22.1313 11.9647 22.2355 12.1206 22.3066 12.2922C22.3776 12.4638 22.4142 12.6477 22.4142 12.8334C22.4142 13.0191 22.3776 13.203 22.3066 13.3746C22.2355 13.5462 22.1313 13.7021 22 13.8334L13.6667 22.1667L11 22.8334L11.6667 20.1667L20 11.8334Z" stroke="#565656" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
    
                                        </button> */}
                      {item.training_processing === 0 ? (
                        <>
                          <div className='flex'>
                            {item.status === 'active' ? (
                              <button
                                data-tooltip-id={'my-tooltip'}
                                data-tooltip-content={'untrained'}
                                data-tooltip-place={'top'}
                                className='text-[18px] flex items-center'
                                title='untrain'
                                onClick={() =>
                                  handleuntraindatasetflashoff(item.dataset_id)
                                }
                              >
                                <IonIcon name='flash-off-outline' />
                              </button>
                            ) : (
                              <button
                                data-tooltip-id={'my-tooltip'}
                                data-tooltip-content={'trained'}
                                data-tooltip-place={'top'}
                                className='text-[18px] flex items-center'
                                title='train'
                                onClick={() =>
                                  handleuntraindatasetflashon(item.dataset_id)
                                }
                              >
                                <IonIcon name='flash-outline' />
                              </button>
                            )}
                            <button
                              data-tooltip-id={'my-tooltip'}
                              data-tooltip-content={'edit'}
                              data-tooltip-place={'top'}
                              className='text-red-500 ml-2 '
                              onClick={() =>
                                handleupdatesingledata(item.dataset_id)
                              }
                            >
                              <svg
                                width='25'
                                height='26'
                                viewBox='0 0 34 35'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle
                                  cx='17'
                                  cy='17.5'
                                  r='16.5'
                                  fill='#EDEDED'
                                  stroke='#DED6D6'
                                />
                                <path
                                  d='M17 22.8334H23M20 11.8334C20.2652 11.5682 20.6249 11.4192 21 11.4192C21.1857 11.4192 21.3696 11.4558 21.5412 11.5268C21.7128 11.5979 21.8687 11.7021 22 11.8334C22.1313 11.9647 22.2355 12.1206 22.3066 12.2922C22.3776 12.4638 22.4142 12.6477 22.4142 12.8334C22.4142 13.0191 22.3776 13.203 22.3066 13.3746C22.2355 13.5462 22.1313 13.7021 22 13.8334L13.6667 22.1667L11 22.8334L11.6667 20.1667L20 11.8334Z'
                                  stroke='#565656'
                                  stroke-width='1.6'
                                  stroke-linecap='round'
                                  stroke-linejoin='round'
                                />
                              </svg>
                            </button>
                            <button
                              data-tooltip-id={'my-tooltip'}
                              data-tooltip-content={'delete'}
                              data-tooltip-place={'top'}
                              className='text-red-500 ml-2 '
                              onClick={() => {
                                handleopendeletepopup(item.dataset_id)
                                // handledeletesingledata(item.dataset_id)
                              }}
                            >
                              <svg
                                width='25'
                                height='26'
                                viewBox='0 0 34 35'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle
                                  cx='17'
                                  cy='17.5'
                                  r='16.5'
                                  fill='#EDEDED'
                                  stroke='#DED6D6'
                                />
                                <path
                                  fill-rule='evenodd'
                                  clip-rule='evenodd'
                                  d='M15.7485 11.5C15.7159 11.4999 15.6835 11.5063 15.6533 11.5187C15.6231 11.5312 15.5957 11.5495 15.5726 11.5726C15.5495 11.5957 15.5312 11.6231 15.5187 11.6533C15.5063 11.6835 15.4999 11.7159 15.5 11.7485L15.5 11.75V12.5H18.5V11.75L18.5 11.7485C18.5001 11.7159 18.4937 11.6835 18.4813 11.6533C18.4688 11.6231 18.4505 11.5957 18.4274 11.5726C18.4043 11.5495 18.3769 11.5312 18.3467 11.5187C18.3165 11.5063 18.2841 11.4999 18.2515 11.5L18.25 11.5H15.75L15.7485 11.5ZM13.0322 13.5L13.624 22.9688C13.6241 22.9707 13.6242 22.9725 13.6243 22.9743C13.6416 23.3108 13.865 23.5 14.125 23.5H19.875C20.1324 23.5 20.3548 23.3151 20.3759 22.9695L20.9678 13.5H13.0322ZM21.4954 12.5H19.5V11.7507C19.5004 11.5865 19.4683 11.4238 19.4057 11.272C19.343 11.1199 19.2508 10.9818 19.1345 10.8655C19.0182 10.7492 18.8801 10.657 18.728 10.5943C18.5762 10.5317 18.4136 10.4996 18.2494 10.5H15.7506C15.5864 10.4996 15.4238 10.5317 15.272 10.5943C15.1199 10.657 14.9818 10.7492 14.8655 10.8655C14.7492 10.9818 14.657 11.1199 14.5943 11.272C14.5317 11.4238 14.4996 11.5864 14.5 11.7506V12.5H12.5046C12.5019 12.5 12.4991 12.5 12.4963 12.5H11.5C11.2239 12.5 11 12.7239 11 13C11 13.2761 11.2239 13.5 11.5 13.5H12.0303L12.6258 23.0287C12.6693 23.8464 13.286 24.5 14.125 24.5H19.875C20.722 24.5 21.3245 23.8406 21.3741 23.0306C21.3741 23.0306 21.3741 23.0305 21.3741 23.0305L21.9697 13.5H22.5C22.7761 13.5 23 13.2761 23 13C23 12.7239 22.7761 12.5 22.5 12.5H21.5037C21.5009 12.5 21.4981 12.5 21.4954 12.5ZM14.7322 14.5003C15.0081 14.4905 15.2398 14.7062 15.2497 14.9822L15.4997 21.9822C15.5095 22.2581 15.2938 22.4898 15.0178 22.4997C14.7419 22.5095 14.5102 22.2938 14.5003 22.0178L14.2503 15.0178C14.2405 14.7419 14.4562 14.5102 14.7322 14.5003ZM19.2678 14.5003C19.5438 14.5102 19.7595 14.7419 19.7497 15.0178L19.4997 22.0178C19.4898 22.2938 19.2581 22.5095 18.9822 22.4997C18.7062 22.4898 18.4905 22.2581 18.5003 21.9822L18.7503 14.9822C18.7602 14.7062 18.9919 14.4905 19.2678 14.5003ZM17 14.5C17.2761 14.5 17.5 14.7239 17.5 15V22C17.5 22.2761 17.2761 22.5 17 22.5C16.7239 22.5 16.5 22.2761 16.5 22V15C16.5 14.7239 16.7239 14.5 17 14.5Z'
                                  fill='#373737'
                                  className='hover:fill-red-700'
                                />
                              </svg>
                            </button>
                          </div>
                        </>
                      ) : (
                        <div className='flex justify-center items-center  w-[60%]'>
                          <Loader size={24} />
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className=''>
            <div className='flex justify-between items-center p-3'>
              <span className='font-[600] text-[12px] '>
                {currentData.length === 0 ? '0' : startItem} - {endItem} of{' '}
                {totalproducts}
              </span>

              <div className='flex items-center'>
                <button
                  onClick={() => handlePageChange('prev')}
                  disabled={currentPage === 1}
                  className=' p-2 '
                >
                  &lt; {/* Left Arrow */}
                </button>
                <span className='mx-2 font-[600] text-[12px]'>
                  Page {currentData.length === 0 ? '0' : currentPage} of{' '}
                  {totalPages}
                </span>
                <button
                  onClick={() => handlePageChange('next')}
                  disabled={currentPage === totalPages}
                  className=' p-2 '
                >
                  &gt; {/* Right Arrow */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

export default Article
